import React, { useEffect, useState } from "react";
import { Form, Input, Button, Typography } from "antd";
import {
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import yoga from "../assets/yoga3.jpg";
import { motion } from "framer-motion";

const { Title, Paragraph } = Typography;

const Contact = () => {
  const [form] = Form.useForm();
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen width
  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 786);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const handleSubmit = (values) => {
    console.log("Form Submitted:", values);
    alert("Thank you for reaching out! We'll get back to you soon.");
    form.resetFields();
  };

  return (
    <motion.div
      style={{
        ...styles.page,
        padding: isMobile ? "80px 10px 20px" : "120px 20px 20px",
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <motion.div
        style={{
          ...styles.card,
          flexDirection: isMobile ? "column" : "row",
          width: isMobile ? "100%" : "900px",
          maxWidth: "900px",
          padding: isMobile ? "20px" : "0",
        }}
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >

        {/* IMAGE FIRST IN MOBILE */}
        {isMobile && (
          <motion.div
            style={{
              ...styles.right,
              width: "100%",
              padding: "10px 0 20px",
            }}
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <img
              src={yoga}
              alt="Contact illustration"
              style={{
                ...styles.img,
                width: "100%",
                borderRadius: "12px",
              }}
            />
          </motion.div>
        )}

        {/* LEFT SIDE – FORM */}
        <motion.div
          style={{
            ...styles.left,
            padding: isMobile ? "20px" : "50px 40px",
          }}
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <Title
            level={2}
            style={{
              marginBottom: "10px",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            Contact Us
          </Title>

          <Paragraph
            style={{
              marginBottom: "25px",
              color: "#555",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            Have questions about our classes, schedules, or trainers? We’d love
            to hear from you! Fill out the form below.
          </Paragraph>

          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            style={{ maxWidth: 350, width: "100%", margin: "0 auto" }}
          >
            <Form.Item
              name="name"
              rules={[{ required: true, message: "Please enter your name" }]}
            >
              <Input placeholder="Name" prefix={<MailOutlined />} />
            </Form.Item>

            <Form.Item
              name="email"
              rules={[
                { required: true, message: "Please enter your email" },
                { type: "email", message: "Enter a valid email" },
              ]}
            >
              <Input placeholder="Email" prefix={<MailOutlined />} />
            </Form.Item>

            <Form.Item
              name="message"
              rules={[{ required: true, message: "Please enter your message" }]}
            >
              <Input.TextArea rows={3} placeholder="Message" />
            </Form.Item>

            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Button type="primary" htmlType="submit" block style={styles.button}>
                Send Message
              </Button>
            </motion.div>
          </Form>

          {/* CONTACT INFO */}
          <motion.div
            style={{
              ...styles.infoBox,
              textAlign: isMobile ? "center" : "left",
            }}
            initial={{ opacity: 0, y: 25 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <p><MailOutlined /> Help.yogarefer@gmail.com</p>
            <p><PhoneOutlined /> +91 96296 10424</p>
            <p><EnvironmentOutlined /> 3/66, sakkudi, Madurai - 20, Tamilnadu, India.</p>
          </motion.div>
        </motion.div>

        {/* IMAGE ON RIGHT FOR DESKTOP */}
        {!isMobile && (
          <motion.div
            style={{
              ...styles.right,
              width: "50%",
            }}
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <img
              src={yoga}
              alt="Contact illustration"
              style={{ ...styles.img, width: "80%", borderRadius: "12px" }}
            />
          </motion.div>
        )}
      </motion.div>
    </motion.div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#e8f3ff",
    padding: "60px 20px",
  },
  card: {
    display: "flex",
    backgroundColor: "#fff",
    borderRadius: "16px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    overflow: "hidden",
  },
  left: {
    flex: 1,
  },
  right: {
    flex: 1,
    backgroundColor: "#f6fbff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  img: {
    height: "auto",
  },
  button: {
    backgroundColor: "#00bcd4",
    border: "none",
    height: "40px",
    fontSize: "16px",
    fontWeight: "bold",
  },
  infoBox: {
    marginTop: "25px",
    color: "#444",
    lineHeight: "1.8",
  },
};

export default Contact;
